import { Routes } from '@angular/router';
import { authGuard, guestGuard } from './core/guards/auth.guard';

export const routes: Routes = [
  { path: '', pathMatch: 'full', redirectTo: 'login' },

  {
    path: 'login',
    canActivate: [guestGuard],
    loadComponent: () =>
      import('./pages/login-page/login-page.component')
        .then(m => m.LoginPageComponent),
  },
  {
    path: 'signup',
    canActivate: [guestGuard],
    loadComponent: () =>
      import('./pages/signup-page/signup-page.component')
        .then(m => m.SignupPageComponent),
  },
  {
    path: 'meeting',
    pathMatch: 'full',
    redirectTo: 'portal/meeting',
  },

  {
    path: 'portal',
    canActivate: [authGuard],
    loadComponent: () =>
      import('./pages/portal-layout/portal-layout.component')
        .then(m => m.PortalLayoutComponent),
    children: [
      { path: '', pathMatch: 'full', redirectTo: 'overview' },
      {
        path: 'overview',
        loadComponent: () =>
          import('./pages/portal-home/portal-home.component')
            .then(m => m.PortalHomeComponent),
      },
      {
        path: 'deadlines',
        loadComponent: () =>
          import('./pages/portal-home/all-deadlines/all-deadlines.component')
            .then(m => m.AllDeadlinesComponent),
      },
      {
        path: 'scholarships/:id',
        loadComponent: () =>
          import('./pages/portal-home/scholarship-detail/scholarship-detail.component')
            .then(m => m.ScholarshipDetailComponent),
      },
      {
        path: 'scholarships',
        loadComponent: () =>
          import('./pages/portal-home/all-scholarships/all-scholarships.component')
            .then(m => m.AllScholarshipsComponent),
      },
      {
        path: 'profile',
        loadComponent: () =>
          import('./pages/portal-profile/portal-profile.component')
            .then(m => m.PortalProfileComponent),
      },
      {
        path: 'meeting',
        loadComponent: () =>
          import('./pages/meeting-page/meeting-page.component')
            .then(m => m.MeetingPageComponent),
      },
      {
        path: 'course-finder',
        loadComponent: () =>
          import('./pages/course-finder/course-finder.component')
            .then(m => m.CourseFinderComponent),
      },
      {
        path: 'ai-course-finder',
        loadComponent: () =>
          import('./pages/ai-course-finder/ai-course-finder.component')
            .then(m => m.AiCourseFinderComponent),
      },
      {
        path: 'applications',
        loadComponent: () =>
          import('./pages/application-module/application-list/application-list')
            .then(m => m.ApplicationList)
      },
      {
        path: 'applications/:id',
        loadComponent: () =>
          import('./pages/application-module/application-view/application-view')
            .then(m => m.ApplicationView),
      },
      {
        path: 'notifications',
        loadComponent: () =>
          import('./pages/portal-home/notifications-page/notifications-page.component')
            .then(m => m.NotificationsPageComponent),
      },
      {
        path: 'tuition',
        loadComponent: () =>
          import('./pages/portal-home/portal-home.component')
            .then(m => m.PortalHomeComponent),
      },
      {
        path: 'service',
        loadComponent: () =>
          import('./pages/services/services')
            .then(m => m.Services),
      },
      {
        path: 'refer',
        loadComponent: () =>
          import('./pages/referral-page/referral-page.component')
            .then(m => m.ReferralPageComponent),
      },
      {
        path: 'students',
        loadComponent: () =>
          import('./pages/portal-home/portal-home.component')
            .then(m => m.PortalHomeComponent),
      },
      {
        path: 'classes',
        loadComponent: () =>
          import('./pages/portal-home/portal-home.component')
            .then(m => m.PortalHomeComponent),
      },
      {
        path: 'messages',
        loadComponent: () =>
          import('./pages/portal-home/portal-home.component')
            .then(m => m.PortalHomeComponent),
      },
      {
        path: 'settings',
        loadComponent: () =>
          import('./pages/portal-home/portal-home.component')
            .then(m => m.PortalHomeComponent),
      },
      {
        path: 'support',
        loadComponent: () =>
          import('./pages/portal-home/portal-home.component')
            .then(m => m.PortalHomeComponent),
      },
    ],
  },

  { path: '**', redirectTo: 'login' },
];
